module.exports = __webpack_public_path__ + "fonts/iconfont.6073b47e.ttf";